import { Card, CardContent } from '@/ui/components'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/ui/components'
import { Label } from '@/ui/components/primitives/label'
import { useTheme, type ThemePreference } from '@/contexts/ThemeContext'

const THEME_OPTIONS: { value: ThemePreference; label: string }[] = [
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
  { value: 'system', label: 'System' }
]

export function PreferencesSection() {
  const { theme, setTheme } = useTheme()

  return (
    <Card className="border-border bg-card shadow-none">
      <CardContent className="p-5">
        <h2 className="text-base font-semibold text-foreground mb-4">
          Preferences
        </h2>
        <div className="space-y-2">
          <Label
            htmlFor="theme-preference"
            className="text-sm font-medium text-foreground"
          >
            Appearance
          </Label>
          <Select
            value={theme}
            onValueChange={(value) => setTheme(value as ThemePreference)}
          >
            <SelectTrigger
              id="theme-preference"
              className="w-full max-w-[200px] border-border bg-background text-foreground"
            >
              <SelectValue placeholder="Theme" />
            </SelectTrigger>
            <SelectContent>
              {THEME_OPTIONS.map((opt) => (
                <SelectItem key={opt.value} value={opt.value}>
                  {opt.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <p className="text-xs text-earth-600 mt-1">
            Choose light, dark, or match your device setting.
          </p>
        </div>
      </CardContent>
    </Card>
  )
}
